import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ALERT_MODAL_STATUS } from '../../../../constant/Common/Modal/Alert/status';
import patchDamage from '../../../../service/Safety/DamageReport/Patch/patchDamage';
import useControlToast from '../../../Common/Toast/useControlToast';
import { SUCCESS_UPDATE } from '../../../../constant/Common/Message/success';
import updateGridData from '../../../../util/Common/Datagrid/Handler/updateGridData';
import updateButtonDisabled from '../../../../util/Common/Controller/Handler/updateButtonDisabled';
import { EDIT_MODE } from '../../../../constant/Safety/Common/mode';

const usePatchDamage = ({
  gridRef,
  setAlertOptions,
  setSeq,
  setIsOpenFormModal,
  setDamageReportInfo,
  modalType,
}) => {
  const { setAlertInfo, setIsOpenAlert } = setAlertOptions;
  const { addToast } = useControlToast();

  const queryClient = useQueryClient();
  const mutator = useMutation({
    mutationFn: patchDamage,
    onSuccess: data => {
      const { photo, ...successData } = data?.data;
      updateGridData({
        gridRef,
        newData: { ...successData },
        isUpdate: true,
      });
      if (modalType === EDIT_MODE?.edit) {
        setDamageReportInfo?.(data?.data);
      }
      addToast({ message: SUCCESS_UPDATE });
    },
    onError: error => {
      setAlertInfo(prev => ({
        status: ALERT_MODAL_STATUS?.ERROR,
        message: error?.message,
      }));
      setIsOpenAlert(prev => true);
    },
    onSettled: (data, error, variables) => {
      if (variables?.buttonRef) {
        updateButtonDisabled({ ref: variables.buttonRef, disabled: false });
      }
    },
  });

  return { ...mutator };
};

export default usePatchDamage;
